import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import moment from 'moment'

import './TimelineCard.scss'

class TimelineCard extends Component {
    render () {
        const date = moment(`${this.props.date.year}-${this.props.date.month ? this.props.date.month : '01'}-${this.props.date.day ? this.props.date.day : null}`, 'YYYY-MM-DD')
        return (
            <div className='TimelineCard'
                data-year   = {this.props.date.year}
                data-month  = {this.props.date.month}
                data-day    = {this.props.date.day}
            >
                <div className='_Date'>
                    {
                        this.props.date.month ?
                                <span className='MonthDay'>
                                <span className='_Month'>
                                    {`${moment(date).format('MMMM')}`}
                                </span>
                                {
                                    this.props.date.day ?
                                        <span className='_Day'>{`${moment(date).format('Do')}`}</span>
                                    : null
                                }
                            </span>

                        : null
                    }
                    <span className='Year'>
                        {`${moment(date).format('YYYY')}`}
                    </span>
                </div>


                <div className='_Card' href={this.props.link}>

                    {
                        this.props.headline ?
                            <h2 className='_Headline'>{this.props.headline}</h2>
                        : null
                    }

                    {
                        this.props.image.map(image => (
                            <div className='_Image'>
                                <img src={`${process.env.PUBLIC_URL}/images/${image}`} alt={this.props.headline} />
                            </div>
                        ))
                    }

                    {
                        this.props.content ?
                            <div className='_Content'>
                                <ReactMarkdown source={this.props.content.trim()} />
                            </div>
                        : null
                    }

                    {
                        this.props.link ?
                            <div className='_Link'>
                                <a href={this.props.link} target='_blank'>
                                    { this.props.linkLabel ? this.props.linkLabel : 'Read More' }
                                </a>
                            </div>
                        : null
                    }

                </div>
            </div>
        )
    }
}

TimelineCard.defaultProps = {
    date: {
        year: null,
        month: null,
        day: null
    },
    headline: null,
    content: null,
    image: null,
}

export default TimelineCard
